import { ApiError, useApiClient } from "@myplant-io/utils/api";
import { useMutation, useQueryClient } from "react-query";
import { ModeStoreEntry } from "../types";

export function useModeStoreEntryEdit() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<
    ModeStoreEntry,
    ApiError,
    { id: string; mode_id: string; description: string }
  >(
    ({ id, mode_id, description }) => {
      return client.fetch<ModeStoreEntry>(`/api/mode-store/${id}`, {
        method: "PUT",
        body: JSON.stringify({ mode_id, description }),
      });
    },
    {
      async onSettled() {
        queryClient.invalidateQueries("mode-store");
        queryClient.invalidateQueries("modes");
      },
    }
  );
}
